export const patchOldPOI = (html) => {
    if(html.match(/carousel\-container/)) return html;

    return html.replace(/<div(.*?)>(.*?)<\/div>/g, '<p>$2</p>');
}
